export const isFeatureEnabled = (flagName: string): boolean =>
  sessionStorage.getItem(flagName) === 'true';

export const isBulkOrchestrationV2Enabled = (): boolean =>
  isFeatureEnabled('isBulkOrchestrationV2Enabled');

export const isSmartOrchestrationEnabled = (): boolean =>
  isFeatureEnabled('smartOrchestrationEnabled');
